const price = [
    // BNB Chain：当前 0.05 BNB。unit 是部署交易里付给平台的 value（wei），
    // 改价时同步修改 content.mjs 里的 fee，否则构建会直接失败。
    // 只改这一处不够：src/seo/content.mjs 里的 fee 要跟着改，
    // 否则构建时费用核对会直接失败（页面读数、费用表、llms.txt 都取这两个来源）。
    {
        name: 56,
        unit: "50000000000000000"
    },
    {
        name: 97,
        unit: "50000000000000000"
    },
    {
        name: 1,
        unit: "20000000000000000"
    },
    {
        name: 1116,
        unit: "10000000000000000000"
    },
    {
        name: 128,
        unit: "2500000000000000000"
    },
    {
        name: 42161,
        unit: "20000000000000000"
    },
    {
        name: 369,
        unit: "100000000000000000000000"
    },{
        name: 20201022,
        unit: "10000000000000000000"
    },{
        name: 7899,
        unit: "100000000000000000000"
    },{
        name: 66,
        unit: "1000000000000000000"
    },{
        name: 59144,
        unit: "10000000000000000"
    },
    {
        name: 8453,
        unit: "20000000000000000"
    }
    ,
    {
        name: 5000,
        unit: "50000000000000000000"
    },{
        name: 719,
        unit: "30000000000000000000"
    },{
        name: 204,
        unit: "100000000000000000"
    },{
        name: 109,
        unit: "30000000000000000000"
    },{
        name: 81457,
        unit: "30000000000000000"
    },{
        name: 4200,
        unit: "300000000000000"
    },{
        name: 137,
        unit: "50000000000000000000"
    },{
        name: 1319,
        unit: "5000000000000000000000"
    },
    {
        name: 534352,
        unit: "20000000000000000"
    },{
        name: 480,
        unit: "20000000000000000"
    },{
        name: 33139,
        unit: "10000000000000000000"
    },{
        name: 146,
        unit: "200000000000000000000"
    },{
        name: 130,
        unit: "20000000000000000"
    },{
        name: 1329,
        unit: "100000000000000000000"
    },{
        name: 25,
        unit: "100000000000000000000"
    },{
        name: 2818,
        unit: "20000000000000000"
    },
    {
        name: 1030,
        unit: "200000000000000000000"
    },
    {
        name: 12343,
        unit: "10000000000000000000"
    },
    {
        name: 9745,
        unit: "20000000000000000000"
    },
    {
        name: 10088,
        unit: "2000000000000000000"
    }, {
        name: 860621,
        unit: "20000000000000000000"
    },{
        name: 143,
        unit: "400000000000000000000"
    }, {
        name: 4663,
        unit: "20000000000000000"
    },{
        name: 5042,
        unit: "20000000000000000"
    },












]

export {
    price
}
